import type { ReferencePdf } from "~/atoms/referencePdf";

export const AMA_GUIDE: ReferencePdf = {
  title: "AMA Guide",
  fileName: "AMA_Guide.pdf",
  // Exact `filename` the OpenSearch `document_chunk_compact` index was built
  // with (see scripts/vector_search/run_vector_indexing_*.log:
  // `=== Indexing 933 pre-chunked file(s) as filename='AMA guide 5th edition' ===`).
  // The `term` filter in general-docs search is case-sensitive, so this
  // string must match the indexed value verbatim.
  searchFilename: "AMA guide 5th edition",
};

export const RATING_TABLES: ReferencePdf = {
  title: "Rating tables",
  fileName: "Rating_Reference_Guide.pdf",
};
